import React from 'react';
export function CloseIcon() {
    return (React.createElement("svg", { viewBox: "0 0 12 12" },
        React.createElement("polygon", { fill: "currentColor", points: "7.42 6 12 1.42 10.58 0 6 4.58 1.42 0 0 1.42 4.58 6 0 10.58 1.42 12 6 7.42 10.58 12 12 10.58 7.42 6" })));
}
//# sourceMappingURL=CloseIcon.js.map